import React from 'react'
import { motion, AnimatePresence } from 'framer-motion';

const Instractors = ({gradientClass, instructors, imageUrl}) => {

  console.log("Instructors: ", instructors);
  return (
    <div>
      {/* Instructor Section */}
      <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
            className={`${gradientClass} p-6 rounded-xl shadow-lg text-white`}
        >
          {instructors.map((instructor, index) => (
            <div key={index} className="flex flex-col md:flex-row md:justify-normal items-center justify-center mb-6">
              <img 
                  src={`${imageUrl}/${instructor.image}`} 
                  alt={instructor.headline}
                  className="w-24 h-24 rounded-full border-4 border-white mb-4 md:mb-0 md:mr-6"
              />
              <div>
                  <h3 className="text-xl font-bold mb-2">{instructor.headline}</h3>
                  <p className="mb-2 font-medium">{instructor.experience}</p>
                  <p className="text-purple-100 mb-3">{instructor.goal}</p>
              </div>
            </div>
          ))}
            
        </motion.div>
    </div>
  )
}

export default Instractors
